<script lang="ts" setup>
import { useAuthStore } from '@/stores/authStore'
import { useRouter } from 'vue-router'

const authStore = useAuthStore()
const router = useRouter()
const user = authStore.user
const logout = async () => {
  await authStore.logout()
  router.push('/')
}
</script>

<template>
  <div class="myCard q-pa-md">
    <h5 class="text-h5 q-mb-md">Profile</h5>
    <div class="row q-gutter-md items-center">
      <q-avatar size="100px">
        <q-img :src="user?.picture">
          <template v-slot:error>
            <q-icon name="mdi-account" size="lg" />
          </template>
        </q-img>
      </q-avatar>
      <div class="col">
        <div class="text text-grey-6">Email</div>
        <div class="text">{{ user?.email }}</div>
      </div>
      <q-btn class="col-12 col-md-2" color="negative" label="Logout" @click="logout" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.q-avatar {
  :deep(.q-avatar__content) {
    border: 4px solid var(--q-secondary);
  }
}
</style>
